import React from 'react';
import Container from '../container';
import Style from './index.less';
import classnames from 'classnames/bind';
import RecordLocaleSelect from '@/pages/PC/RecordPanel/RecordLocaleSelect/v2';

export default function Wrapper() {
  const $c = classnames.bind(Style);
  return <Container RecordLocaleSelect={RecordLocaleSelect} $c={$c}></Container>;
}
